import BodyText from "./BodyText";
import Box from "./Box";
import CO2Icon from "../assets/Icn-Co2Cloud.svg";
import GreenIcon from "./GreenIcon";
import PropTypes from "prop-types";
import React from "react";
import TapIcon from "../assets/Icn-Tap.svg";
import Text from "./Text";

function SustainabilityCredentials({ water, cO2 }) {
  return (
    <Box>
      <Text
        lineHeight="36px"
        fontSize={[14, 14, 16, 16]}
        color="green"
        mb={[0, null, "10px", null]}
      >
        By reusing this item you've saved
      </Text>
      <Box display="flex">
        {water && (
          <Box pr={14}>
            <GreenIcon
              icon={<TapIcon aria-label="Tap" />}
              label={`${water} litres`}
            />
          </Box>
        )}
        {cO2 && (
          <Box>
            <GreenIcon icon={<CO2Icon aria-label="CO2" />} label={`${cO2}kg`} />
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default SustainabilityCredentials;

SustainabilityCredentials.propTypes = {
  water: PropTypes.number,
  cO2: PropTypes.number,
};
